module.exports = __webpack_public_path__ + "img/icon-lottery-white.b31e8d25.svg";